module.exports = __webpack_public_path__ + "static/media/new_subscriptions_chart.f86f6e2d.svg";